import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../../contexts/AuthContext';
import './AdminPanel.scss';

const Login = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const success = login(password);
      if (success) {
        navigate('/admin');
      } else {
        setError('Invalid password. Please try again.');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      className="login-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="login-container">
        <motion.div
          className="login-card"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          <div className="login-header">
            <h1 className="login-title">Admin Login</h1>
            <p className="login-subtitle">Please enter your password to access the admin panel</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-control"
                placeholder="Enter admin password"
                required
                disabled={loading}
              />
            </div>

            {error && (
              <div className="alert alert-error">
                <span className="alert-icon">⚠️</span>
                {error}
              </div>
            )}

            <div className="form-actions">
              <button
                type="submit"
                className="btn btn-primary btn-block"
                disabled={loading || !password}
              >
                {loading ? (
                  <>
                    <span className="spinner"></span>
                    Authenticating...
                  </>
                ) : (
                  'Login'
                )}
              </button>
            </div>

            <div className="login-footer">
              <p className="security-note">
                <span className="lock-icon">🔒</span>
                For security, please log out after your session.
              </p>
              <p className="demo-note">
                Demo password: <code>admin123</code>
              </p>
            </div>
          </form>
        </motion.div>

        <motion.div
          className="login-info"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
        >
          <h3>Security Information</h3>
          <ul>
            <li>Access restricted to authorized personnel only</li>
            <li>Session expires after 24 hours of inactivity</li>
            <li>All actions are logged for security audit</li>
            <li>Use strong passwords and keep them confidential</li>
          </ul>
          
          <div className="warning-box">
            <strong>⚠️ Important:</strong> This is a demo system. In production, use environment variables for passwords.
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Login;